// 代建與接手的 kmgr API（M5-03；SPEC #kinio-kms-handover）：都走 kmgr token（../api.ts kmgrFetch），mock 開關同 KMS 操作台。
//
//   GET  /v1/orgs/{org}/kmgr/handover                組織 owner / org_admin：接手進度（不是代建中 404）
//   POST /v1/orgs/{org}/kmgr/handover/request-sign   接手客戶：請代建者加入他的金鑰（202 {sent, next_at}；1 小時一次）
//   POST /v1/orgs/{org}/kmgr/handover/steps          接手客戶：③ {delegation, skip}、④ {template, keep / revert}（revert 要 step-up）
// 平台那邊（邀請、擁有權、退出、代建清單）在 lib/planeApi.ts。
import { kmgrFetch } from '../api';
import type { Handover } from './types';

const base = (org: string) => `/v1/orgs/${encodeURIComponent(org)}/kmgr/handover`;

export const handoverApi = {
  get: (api: string, org: string) => kmgrFetch<Handover>(api, base(org)),
  requestSign: (api: string, org: string) => kmgrFetch<{ sent: boolean; next_at: string }>(api, `${base(org)}/request-sign`, { method: 'POST' }),
  step: (api: string, org: string, step: 'delegation' | 'template', decision: 'skip' | 'keep' | 'revert') =>
    kmgrFetch<Handover>(api, `${base(org)}/steps`, { method: 'POST', body: { step, decision } }),
};
